import FilterListList from 'common/pages/filter-list/FilterListList'

export const FilterListListAgency = (props) =>
    <FilterListList {...props} agency />